import { createSlice } from "@reduxjs/toolkit";
import { distributorInitialState } from "src/models/master_data/distributor/distributor.dto";
import { createMsDistributorThunk, fetchMsDistributorThunk, submitMsDistributorThunk, uploadMsDistributorThunk } from "../action/distributor.action";

export const msDistributorSlice = createSlice({
    name: 'msDistributor',
    initialState: distributorInitialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get All Items
        builder
            .addCase(fetchMsDistributorThunk.fulfilled, (state, action) => {
              
                state.data = action.payload.data;
                state.pagination=action.payload.pagination
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(fetchMsDistributorThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(fetchMsDistributorThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Create Item
        builder
            .addCase(createMsDistributorThunk.fulfilled, (state, action) => {
                state.data.push(action.payload.data); 
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(createMsDistributorThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(createMsDistributorThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Upload Prices
        builder
            .addCase(uploadMsDistributorThunk.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(uploadMsDistributorThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(uploadMsDistributorThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Submit Prices
        builder
            .addCase(submitMsDistributorThunk.fulfilled, (state, action) => {
                state.data = action.payload.data; 
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(submitMsDistributorThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(submitMsDistributorThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

    },
});

export default msDistributorSlice.reducer;
